import { useState } from 'react'

import { useCMS } from '@tribeplatform/react-components/CMS'
import { EntityImage } from '@tribeplatform/react-components/common/components'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Input } from '@tribeplatform/react-ui-kit/Input'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

export const ManagePostTypesSidebar = () => {
  const { $t } = useI18n()
  const [query, setQuery] = useState('')
  const { postTypes } = useCMS()
  const { Link } = useRouter()

  const foundPostTypes = postTypes.filter(postType => {
    return postType.name?.toLowerCase().includes(query.toLowerCase())
  })

  return (
    <>
      <Input
        leadingIcon={<SvgIcon name="search" />}
        placeholder={$t({ defaultMessage: 'Search', id: 'Generics.Search' })}
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      <NavVertical>
        <NavVertical.Group className="mt-3">
          <div className="space-y-1 flex flex-col">
            {foundPostTypes.map(({ id, icon, name }) => (
              <NavVertical.Item
                key={id}
                as={Link}
                href={`/manage/customizer/cms/${id}/blocks`}
                leadingAddon={
                  <div className="me-3">
                    <EntityImage size="lg" entity={{ image: icon, name }} />
                  </div>
                }
              >
                {name}
              </NavVertical.Item>
            ))}
          </div>
        </NavVertical.Group>
      </NavVertical>
    </>
  )
}
